<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Lista de Proyectos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button v-if="enabledExcel" @click="exportaExcel()" type="button" class="btn-success">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <k-table
      :filterStatus="filterStatus"
      :editButton="false"
      :deleteButton="false"
      :createButton="false"
      :fechas="true"
      ref="listaProyectos"
      @seleccionar="seleccionar"
      :path="url + '/proyectos'"
      :columns="[
        {
          display: 'Código',
          value: 'codigo'
        },
        {
          display: 'Nombre',
          value: 'nombre'
        },
        {
          display: 'Descripción',
          value: 'descripcion'
        },
        {
          display: 'Fecha inicio',
          value: 'fecha_inicio'
        },
        {
          display: 'Estado',
          value: 'nombre_estado'
        },
        {
          display: 'Fecha de creación',
          value: 'created_at'
        },
        {
          display: 'Fecha de modificación',
          value: 'updated_at'
        }
      ]"
    ></k-table>
  </div>
</template>
<script>
export default {
  props: {
    filterStatus: {
      type: Boolean,
      required: false,
      default: true
    },
    enabledExcel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      currentIndex: -1,
      url: url
    }
  },
  methods: {
    exportaExcel: function(){
      window.open(url + '/proyectos?exportar=S', '_blank');
    },
    seleccionar: function(current){
      this.$emit("selected", current);
      this.$modal.hide('modalListaProyectos');
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/procesos/ListaProyectos.vue